<template lang="pug">
.v-bill-promo.bill-promo(v-if="data && data.items" :class="{'bill-promo--wrap-mob': wrapMob}" :id="data?.id")
	.bill-promo__item(v-for="item in isTablet ? data.items.slice().reverse() : data.items " :style="{'background': item.background}")
		.bill-promo__item-head(v-if="isTablet" @click="active = active === item ? null : item")
			.bill-promo__item-head-title(v-if="item.title" :style="{'color': item.title.color}" v-html="item.title.text")
			.bill-promo__item-head-btn(v-if="!wrapMob")
				v-svg-icon.bill-promo__item-head-btn-icon(:icon="active === item ? 'minus' : 'plus'")
		component(:is="wrapMob ? 'div' : 'v-collapse'" :class="{'bill-promo__item-body-wrapper':wrapMob}" :open="wrapMob ? null : ((isTablet && active === item) || !isTablet)")
			.bill-promo__item-body
				img.bill-promo__icon(v-if="item.icon" :src="item.icon")
				.bill-promo__title(v-if="item.title && !isTablet" :style="{'color': item.title.color}" v-html="item.title.text")
				.bill-promo__features(v-if="item.features")
					.bill-promo__feature(v-for="feature in item.features.items")
						span.bill-promo__feature-title(v-if="feature.title" :style="{'color': item.features.titleColor, 'background': item.features.titleBackground}") {{feature.title}}
						.bill-promo__feature-text(v-if="feature.text" :style="{'color': item.features.textColor}") {{feature.text}}
				.bill-promo__advantages(v-if="item.advantages")
					.bill-promo__advantage(v-for="advantage in item.advantages.items")
						.bill-promo__advantage-text(v-if="advantage.text" :style="{'color': item.advantages.textColor}") {{advantage.text}}
				.bill-promo__actions(v-if="item.actions")
					template(v-for="action in item.actions")
						a.bill-promo__action.btn(v-if="action.link" :href="action.link" :class="action.className") {{action.text}}
						button.bill-promo__action.btn(v-else="" type="button" :class="action.className" @click="action.field ? scrollToForm(action.field) : null") {{action.text}}
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";
import controller from "../scripts/controller/controller.js";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		wrapMob: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			data: null,
			active: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.active = data.items[0] || null;
		},

		scrollToForm(field) {
			controller.events.emit('setFormFieldValue', field);
		}
	}
}
</script>